<script setup>
import BoundedComponent from '@/components/BoundedComponent.vue';
import BackgroundImage from '@/components/BackgroundImage.vue';
import AccordionComponent from '@/components/AccordionComponent.vue';

const questions = [
  {
    q: 'Hvað finnst þér vera eðlilegur skjátími á dag fyrir þig?',
    a: 'Prófaðu að skoða skjátímann í símanum þínum, er hann í takti við þínar væntingar?',
  },
  {
    q: 'Taktu nú saman allan annan skjátíma',
    a: [
      'Teldu með tímann sem fer í að spila tölvuleiki, nota spjaldtölvu og horfa á sjónvarpið. Hversu mikill tími fer í að horfa á skjá á dag?',
      'Eru þeir allir eins? Flest sjónvörp senda okkur ekki tilkynningar og því minna áreiti sem fylgir því að horfa á bíómynd en að fletta gegnum TikTok með öll hin öppin í tækinu að kalla á athygli um leið.',
    ],
  },
  {
    q: 'Ertu að nota marga skjái á sama tíma? ',
    a: 'T.d. að skruna í símanum á meðan þú horfir á þátt? Hvernig líður þér þegar þú hefur verið lengi fyrir framan skjá?',
  },
  {
    q: 'Hvenær leitar þú í skjátæki?',
    a: [
      'Í langri bílferð? Prófaðu að nýta tímann í leiki með þeim sem eru með þér í bílnum. T.d. Hver er maðurinn, Ríkjaleikinn, El grande eða lagaleik.',
      'Á koddanum fyrir svefn? Prófaðu að hlusta eða lesa í staðinn fyrir að spila leik eða horfa á myndbönd á samfélagsmiðlum.',
      'Í samverustund með vinum eða fjölskyldu? Prófum að spila og horfa saman frekar en að spila eða horfa ein, hvert í sínu horni.',
      'Hvað með biðstofuna? Í strætó? Eða þegar fólk er að tala um eitthvað í kringum okkur sem við höfum ekki áhuga á? Getum við gert eitthvað annað í þeim aðstæðum en að fara í símann?',
    ],
  },
];
</script>

<template>
  <section class="mb-41">
    <!-- bg image -->
    <BackgroundImage
      src="/images/boy-in-cinema.webp"
      src2="/images/boy-in-cinema-after.webp"
      alt="strákur í bíó"
      start="160"
      startMobile="-50"
      class="-mt-40 md:-mt-20 xl:-mt-60 -mb-50 xl:-mb-100"
    />
    <BoundedComponent class-name="mb-10">
      <!-- heading -->
      <h2 v-fade-up class="mb-3 lg:mb-17.5">Hugsum málið!</h2>
      <AccordionComponent :questions="questions" version="2" />
    </BoundedComponent>
  </section>
</template>
